import { maxSpacingValue as j, minSpacingValue as q } from "../../theme/spacing.js";
import { isBetweenInclusive as t } from "../isBetweenInclusive/index.js";
import '../../assets/index19.css';const r = {
  "m-0": "_m-0_1cj9q_2",
  "m-1": "_m-1_1cj9q_5",
  "m-2": "_m-2_1cj9q_8",
  "m-3": "_m-3_1cj9q_11",
  "m-4": "_m-4_1cj9q_14",
  "m-5": "_m-5_1cj9q_17",
  "m-6": "_m-6_1cj9q_20",
  "m-7": "_m-7_1cj9q_23",
  "m-8": "_m-8_1cj9q_26",
  "m-9": "_m-9_1cj9q_29",
  "m-10": "_m-10_1cj9q_32",
  "mt-0": "_mt-0_1cj9q_40",
  "mt-1": "_mt-1_1cj9q_43",
  "mt-2": "_mt-2_1cj9q_46",
  "mt-3": "_mt-3_1cj9q_49",
  "mt-4": "_mt-4_1cj9q_52",
  "mt-5": "_mt-5_1cj9q_55",
  "mt-6": "_mt-6_1cj9q_58",
  "mt-7": "_mt-7_1cj9q_61",
  "mt-8": "_mt-8_1cj9q_64",
  "mt-9": "_mt-9_1cj9q_67",
  "mt-10": "_mt-10_1cj9q_70",
  "mr-0": "_mr-0_1cj9q_78",
  "mr-1": "_mr-1_1cj9q_81",
  "mr-2": "_mr-2_1cj9q_84",
  "mr-3": "_mr-3_1cj9q_87",
  "mr-4": "_mr-4_1cj9q_90",
  "mr-5": "_mr-5_1cj9q_93",
  "mr-6": "_mr-6_1cj9q_96",
  "mr-7": "_mr-7_1cj9q_99",
  "mr-8": "_mr-8_1cj9q_102",
  "mr-9": "_mr-9_1cj9q_105",
  "mr-10": "_mr-10_1cj9q_108",
  "mb-0": "_mb-0_1cj9q_116",
  "mb-1": "_mb-1_1cj9q_119",
  "mb-2": "_mb-2_1cj9q_122",
  "mb-3": "_mb-3_1cj9q_125",
  "mb-4": "_mb-4_1cj9q_128",
  "mb-5": "_mb-5_1cj9q_131",
  "mb-6": "_mb-6_1cj9q_134",
  "mb-7": "_mb-7_1cj9q_137",
  "mb-8": "_mb-8_1cj9q_140",
  "mb-9": "_mb-9_1cj9q_143",
  "mb-10": "_mb-10_1cj9q_146",
  "ml-0": "_ml-0_1cj9q_154",
  "ml-1": "_ml-1_1cj9q_157",
  "ml-2": "_ml-2_1cj9q_160",
  "ml-3": "_ml-3_1cj9q_163",
  "ml-4": "_ml-4_1cj9q_166",
  "ml-5": "_ml-5_1cj9q_169",
  "ml-6": "_ml-6_1cj9q_172",
  "ml-7": "_ml-7_1cj9q_175",
  "ml-8": "_ml-8_1cj9q_178",
  "ml-9": "_ml-9_1cj9q_181",
  "ml-10": "_ml-10_1cj9q_184",
  "p-0": "_p-0_1cj9q_189",
  "p-1": "_p-1_1cj9q_192",
  "p-2": "_p-2_1cj9q_195",
  "p-3": "_p-3_1cj9q_198",
  "p-4": "_p-4_1cj9q_201",
  "p-5": "_p-5_1cj9q_204",
  "p-6": "_p-6_1cj9q_207",
  "p-7": "_p-7_1cj9q_210",
  "p-8": "_p-8_1cj9q_213",
  "p-9": "_p-9_1cj9q_216",
  "p-10": "_p-10_1cj9q_219",
  "pt-0": "_pt-0_1cj9q_227",
  "pt-1": "_pt-1_1cj9q_230",
  "pt-2": "_pt-2_1cj9q_233",
  "pt-3": "_pt-3_1cj9q_236",
  "pt-4": "_pt-4_1cj9q_239",
  "pt-5": "_pt-5_1cj9q_242",
  "pt-6": "_pt-6_1cj9q_245",
  "pt-7": "_pt-7_1cj9q_248",
  "pt-8": "_pt-8_1cj9q_251",
  "pt-9": "_pt-9_1cj9q_254",
  "pt-10": "_pt-10_1cj9q_257",
  "pr-0": "_pr-0_1cj9q_265",
  "pr-1": "_pr-1_1cj9q_268",
  "pr-2": "_pr-2_1cj9q_271",
  "pr-3": "_pr-3_1cj9q_274",
  "pr-4": "_pr-4_1cj9q_277",
  "pr-5": "_pr-5_1cj9q_280",
  "pr-6": "_pr-6_1cj9q_283",
  "pr-7": "_pr-7_1cj9q_286",
  "pr-8": "_pr-8_1cj9q_289",
  "pr-9": "_pr-9_1cj9q_292",
  "pr-10": "_pr-10_1cj9q_295",
  "pb-0": "_pb-0_1cj9q_303",
  "pb-1": "_pb-1_1cj9q_306",
  "pb-2": "_pb-2_1cj9q_309",
  "pb-3": "_pb-3_1cj9q_312",
  "pb-4": "_pb-4_1cj9q_315",
  "pb-5": "_pb-5_1cj9q_318",
  "pb-6": "_pb-6_1cj9q_321",
  "pb-7": "_pb-7_1cj9q_324",
  "pb-8": "_pb-8_1cj9q_327",
  "pb-9": "_pb-9_1cj9q_330",
  "pb-10": "_pb-10_1cj9q_333",
  "pl-0": "_pl-0_1cj9q_341",
  "pl-1": "_pl-1_1cj9q_344",
  "pl-2": "_pl-2_1cj9q_347",
  "pl-3": "_pl-3_1cj9q_350",
  "pl-4": "_pl-4_1cj9q_353",
  "pl-5": "_pl-5_1cj9q_356",
  "pl-6": "_pl-6_1cj9q_359",
  "pl-7": "_pl-7_1cj9q_362",
  "pl-8": "_pl-8_1cj9q_365",
  "pl-9": "_pl-9_1cj9q_368",
  "pl-10": "_pl-10_1cj9q_371"
};
function e(_) {
  const c = {};
  if (typeof _ != "object")
    return c;
  for (const m in _) {
    const p = _[m];
    t(p, q, j) && (c[r[`${m}-${String(p)}`]] = !0);
  }
  return c;
}
export {
  e as getSpacingClasses
};
//# sourceMappingURL=index.js.map
